import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../../routes/routeName';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import StateComponents from '../../../../components/state-component/StateComponents';
import { produce } from 'immer';
import ImageUploadContent from '../element/ImageUploadContent';
import ModalMedia from '../../media/modal-media/ModalMedia';
import { GalleryApi, galleryDetailType } from '../../../../api/gallery/gallery.api';
import moment from 'moment';
import { GALLERY_CATEGORY } from '../enum';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import ContainerButton from '../../../../components/button/ContainerButton';
import { IconComponents } from '../../../../assets/icons/icons';
import { RatingBox } from '../element/RatingBox';
import { STATUS_DATA } from '../../../../constants';
import StepperCustom from '../../../../components/step/Stepper';
import StarsIcon from '@mui/icons-material/Stars';
import DescriptionIcon from '@mui/icons-material/Description';

type Props = {
    view: boolean;
}


const CollectionsImageDetail: React.FC<Props> = ({ view }: Props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [step, setStep] = useState<number>(0);

    type formStateType = {
        is_public: string;
        start_date: string;
        end_date: string;
        start_time: string;
        end_time: string;
        gallery_name: string;
    }
    const [formState, setFormState] = useState<formStateType>({
        is_public: "0",
        end_date: "",
        start_date: "",
        start_time: "",
        end_time: "",
        gallery_name: "",
    })
    const [count_data, set_count_data] = useState<{ total_like: number, total_view: number, total_shared: number }>({
        total_like: 0,
        total_shared: 0,
        total_view: 0
    })

    const [showModal, setShowModal] = useState<boolean>(false);
    const [is_delete, set_is_delete] = useState<boolean>(false);
    const [status, set_status] = useState<string>("");

    const [id_media_file, set_id_media_file] = useState<{
        id_media_file: number,
        media_file_path: string,
        media_file_name: string,
        id_gallery_file?: number
    }[]>([]);
    const [id_gallery_type, set_id_gallery_type] = useState<{
        id_gallery_type: number | null,
        gallery_type_name: string
    } | null>(null);
    const [gallery_type_data, set_gallery_type_data] = useState<any[]>([]);

    const handleChangeFormState = (field: keyof formStateType, value: string) => {
        setFormState((prev) =>
            produce(prev, (draft) => {
                draft[field] = value;
            })
        );
    };

    const handleDeleteImage = (index_file: number) => {
        set_id_media_file((prev) => {
            return produce(prev, (draft) => {
                draft.splice(index_file, 1);
            });
        });
    };



    const handleCloseModal = () => {
        setShowModal(false);
    }
    const generateForm = (mode: "DRAFT" | "SUBMIT"): galleryDetailType => {
        const start_date = formState.start_date
            ? moment(
                `${moment(formState.start_date).format("YYYY-MM-DD")}${formState.start_time ? ` ${formState.start_time}` : ''}`
            ).format(formState.start_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : null;

        const end_date = formState.end_date
            ? moment(
                `${moment(formState.end_date).format("YYYY-MM-DD")}${formState.end_time ? ` ${formState.end_time}` : ''}`
            ).format(formState.end_time ? "YYYY-MM-DD[T]HH:mm" : "YYYY-MM-DD")
            : null;
        return {
            end_date: end_date,
            start_date: start_date,
            gallery_category: GALLERY_CATEGORY.IMAGE,
            gallery_name: formState.gallery_name,
            id_gallery_type: id_gallery_type?.id_gallery_type || null,
            is_draft: mode === 'DRAFT',
            is_public: mode === 'SUBMIT' ? true : +formState.is_public ? true : false,
            media_files: id_media_file?.length > 0 ? id_media_file?.map((list) => {
                return {
                    id_media_file: list?.id_media_file,
                    id_gallery_file: list?.id_gallery_file,
                    gallery_link: ""
                }
            }) : [],
        }
    }
    const handleSubmit = async (mode: "DRAFT" | "SUBMIT") => {
        const body = generateForm(mode);
        dispatch(setLoading());
        if (id) {
            await GalleryApi.update(+id, body).then((res) => {
                if (res.status < 300) {
                    set_is_delete(false);
                    alertSuccess("อัพเดตภาพถ่าย", "อัพเดตภาพถ่าย เรียบร้อยแล้ว", undefined, () => {
                        handleGetDetail(+id);
                    });
                }
            }).catch((err) => {
                console.log(err)
                alertError("อัพเดตภาพถ่าย", "อัพเดตภาพถ่าย ไม่สำเร็จ")
            }).finally(() => dispatch(unsetLoading()))
        } else {
            await GalleryApi.create(body).then((res) => {
                if (res.status < 300) {
                    set_is_delete(false);
                    alertSuccess("เพิ่มภาพถ่าย", "เพิ่มภาพถ่าย เรียบร้อยแล้ว", undefined, () => {
                        const id_gallery = res.data?.data?.id_gallery;
                        if (id_gallery) {
                            window.location.replace(routeName.cms_website.collection_image_detail.replace(":id", id_gallery))
                        } else {
                            navigate(routeName.cms_website.collection_image)
                        }
                    });

                }
            }).catch((err) => {
                console.log(err)
                alertError("เพิ่มภาพถ่าย", "เพิ่มภาพถ่าย ไม่สำเร็จ")
            }).finally(() => dispatch(unsetLoading()))
        }
    }

    const handleGetGalleryTypeData = async () => {
        await GalleryApi.findDropdownType().then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data || [];
                set_gallery_type_data(data_value)
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleGetDetail = async (id_gallery: number) => {
        dispatch(setLoading());
        await GalleryApi.findOne(id_gallery).then((res) => {
            if (res.status < 300) {
                const data_value = res.data?.data;
                setFormState((prev => ({
                    ...prev,
                    start_date: data_value?.start_date,
                    end_date: data_value?.end_date,
                    gallery_name: data_value?.gallery_name,
                    end_time: data_value?.end_date ? moment(data_value?.end_date).format("HH:mm") : "",
                    start_time: data_value?.start_date ? moment(data_value?.start_date).format("HH:mm") : "",
                    is_public: String(data_value?.is_public ?? 0)
                })))
                set_count_data({
                    total_like: data_value?.total_like || 0,
                    total_shared: data_value?.total_shared || 0,
                    total_view: data_value?.total_view || 0
                })
                set_id_gallery_type({ id_gallery_type: data_value?.id_gallery_type || null, gallery_type_name: "" })
                set_status(data_value?.status || "");
                set_id_media_file(data_value?.file || []);
                // console.log(data_value, 'da')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    useEffect(() => {
        if (id && !isNaN(+id)) {
            handleGetDetail(+id);
        }
        handleGetGalleryTypeData();
    }, [])
    return (
        <ContainerLayout
            title=''
            titleName='เพิ่มภาพถ่าย'
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        {
                            key: "แกลเลอรี",
                            name: "แกลเลอรี",
                            pathName: "",
                            disabled_match: true
                        },
                        {
                            key: "ภาพถ่าย",
                            name: "ภาพถ่าย",
                            pathName: routeName.cms_website.collection_image,
                            disabled_match: true
                        },
                        {
                            key: "ภาพถ่าย",
                            name: id ? "รายละเอียดภาพถ่าย" : "เพิ่มภาพถ่าย",
                            pathName: (id && view) ? routeName.cms_website.collection_image_view.replace(":id", id) : id ? routeName.cms_website.collection_image_detail.replace(":id", id) : routeName.cms_website.collection_image_create,
                        },
                    ]}
                />
            }
            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    sxContainer={{ maxWidth: "fit-content" }}
                    buttonData={[
                        {
                            key: "BACK",
                            buttonProps: {
                                onClick: () => navigate(-1)
                            },
                            label: "ย้อนกลับ",
                            seq: 1,
                            type: "BACK"
                        },
                        {
                            key: "SAVE_DRAFT",
                            hidden: view || status === STATUS_DATA.ACTIVE,
                            buttonProps: {
                                onClick: () => handleSubmit("DRAFT")
                            },
                            label: "บันทึกร่าง",
                            seq: 2,
                            type: "SAVE_DRAFT"
                        },
                        {
                            key: "SAVE",
                            hidden: view,
                            buttonProps: {
                                onClick: () => {
                                    alertActive("บันทึกข้อมูล", "ท่านต้องการบันทึกข้อมูลพร้อมเผยแพร่เนื้อหา?", "บันทึกพร้อมเผยแพร่", "ยกเลิก", () => {
                                        handleSubmit("SUBMIT")
                                    })
                                }
                            },
                            label: "บันทึก",
                            seq: 3,
                            type: "SAVE"
                        },
                    ]}
                />
            }
            content={
                <>
                    {STATUS_DATA.ACTIVE === status && (
                        <div className='flex justify-center items-center'>
                            <StepperCustom
                                sx={{ maxWidth: 'fit-content' }}
                                setStep={(s) => setStep(s)}
                                step={step}
                                view
                                stepLabel={[
                                    {
                                        icon: <DescriptionIcon />,
                                        isAccept: false,
                                        name: "รายละเอียด",
                                    },
                                    {
                                        icon: <StarsIcon />,
                                        isAccept: false,
                                        name: "การเข้าถึง",
                                    },
                                ]}
                            />
                        </div>
                    )}
                    {step === 0 && (
                        <Box className="w-full">
                            <StateComponents
                                disabledAllField={view}
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "SWITCH",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            checked: +formState.is_public ? true : false,
                                            onChange: (e) => handleChangeFormState('is_public', e ? "1" : "0"),
                                            label: "สถานะการเผยแพร่",
                                            disabled: view
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            heading: "วันที่เริ่มต้นเผยแพร่",
                                            placeholder: 'ระบุวันที่เริ่มต้นเผยแพร่',
                                            onChange: (e) => handleChangeFormState('start_date', e),
                                            value: formState.start_date,
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            heading: "วันที่สิ้นสุดเผยแพร่",
                                            placeholder: 'ระบุวันที่สิ้นสุดเผยแพร่',
                                            disabled: !formState.start_date,
                                            disableStartDate: formState.start_date,
                                            onChange: (e) => handleChangeFormState('end_date', e),
                                            value: formState.end_date,
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            heading: "เวลาที่เริ่มต้นเผยแพร่",
                                            placeholder: 'ระบุเวลาที่เริ่มต้นเผยแพร่',
                                            onChange: (e) => handleChangeFormState('start_time', e),
                                            value: formState.start_time,
                                        }
                                    },
                                    {
                                        seq: 5,
                                        type: "TIME_PICKER",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            heading: "เวลาที่สิ้นสุดเผยแพร่",
                                            placeholder: 'ระบุเวลาที่สิ้นสุดเผยแพร่',
                                            onChange: (e) => handleChangeFormState('end_time', e),
                                            value: formState.end_time,
                                        }
                                    },
                                    {
                                        seq: 6,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            onChange: (e) => handleChangeFormState('gallery_name', e.target.value),
                                            heading: "ชื่อ",
                                            required: true,
                                            value: formState.gallery_name,
                                            placeholder: 'ระบุชื่อ'
                                        }
                                    },
                                    {
                                        seq: 7,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            labelId: "id_gallery_type",
                                            options: gallery_type_data,
                                            getOptionLabel: ({ gallery_type_name }: { gallery_type_name: string }) => gallery_type_name || "",
                                            onChange: (_, val) => {
                                                set_id_gallery_type(val ?? null);
                                            },
                                            heading: "หมวดหมู่",
                                            value: gallery_type_data?.find((x) => x?.id_gallery_type === id_gallery_type?.id_gallery_type) || null,
                                            placeholder: 'ระบุหมวดหมู่'
                                        }
                                    },
                                ]}
                            />


                            <ModalMedia
                                handleClose={handleCloseModal}
                                open={showModal}
                                id_media_file={null}
                                title=''
                                onSubmitLocalFile={(id_media_file) => {

                                }}
                                // onSubmitMediaFile={}
                                onSubmitMediaFileMultiple={(data) => {
                                    set_id_media_file((prev) => ([...prev, ...data]));
                                }}
                                onSelectMediaFile={(_, id_media_file, media_file_path, media_file_name) => {
                                    // console.log(id_media_file)
                                }}
                                multiple={true}
                            />
                            <ImageUploadContent
                                is_delete={is_delete}
                                handleDeleteImage={handleDeleteImage}
                                data={id_media_file}
                                disabled_delete={id_media_file.length === 0}
                                view={view}
                                onDeleteClick={() => {
                                    set_is_delete((prev => !prev));
                                }}
                                onAdd={() => {
                                    setShowModal(true);
                                }}
                            />
                        </Box>
                    )}

                    {step === 1 && (
                        <Box className="w-full flex gap-4 items-center justify-center py-5">
                            {
                                [
                                    { label: "ยอดการถูกใจ", icon: <IconComponents.HeartIcon />, count: count_data?.total_like },
                                    { label: "ยอดการเข้าชม", icon: <IconComponents.ViewIcon />, count: count_data?.total_view },
                                    { label: "ยอดการแชร์", icon: <IconComponents.SharedIcon />, count: count_data?.total_shared },
                                ].map((list) => {
                                    return (
                                        <RatingBox
                                            IconData={list.icon}
                                            count={list.count}
                                            title={list.label}
                                        />
                                    )
                                })
                            }
                        </Box>
                    )}
                </>
            }
        />
    )
}

export default CollectionsImageDetail